const filter = [
  { text: 'Название', value: 'name' },
];

const sort = [
  { text: 'По названию', value: 'name', type: 'asc', default: true },
  { text: 'По названию', value: 'name', type: 'desc' }
];

export { filter, sort };